import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileManagerComponent } from './file-manager.component';
import {CommonModule} from "@angular/common";
import { FormsModule } from '@angular/forms';
import { DragDirective } from './dragDrop.directive';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
    declarations: [
        FileManagerComponent,

    ],
    imports     : [
        MatButtonModule,
        MatIconModule,
        MatSidenavModule,
        MatTooltipModule,
        CommonModule,
        FormsModule,
        TranslocoModule
    ],
    exports     : [
        FileManagerComponent
    ],
})
export class FileManagerModule
{
}
